/**
 * Servicio API para registro de clientes
 * API específica para el módulo de registro público sin autenticación
 */

import { API_BASE_URL } from '../config/api'

/**
 * Obtener configuración de registro (planes disponibles)
 */
export const obtenerConfiguracionRegistro = async () => {
  try {
    const response = await fetch(`${API_BASE_URL}/configuracion_registro/publico`)
    if (!response.ok) {
      throw new Error(`HTTP ${response.status}: ${response.statusText}`)
    }
    const data = await response.json()
    return data
  } catch (error) {
    console.error('Error obteniendo configuración de registro:', error)
    throw error
  }
}

/**
 * Obtener planes públicos
 */
export const obtenerPlanesPublicos = async () => {
  try {
    const response = await fetch(`${API_BASE_URL}/planes/publico`)
    if (!response.ok) {
      throw new Error(`HTTP ${response.status}: ${response.statusText}`)
    }
    const data = await response.json()

    // Filtrar el plan con id=1 (Plan Help) - no mostrarlo en registro público
    const planesVisibles = data.filter(plan => plan.id !== 1)

    return planesVisibles
  } catch (error) {
    console.error('Error obteniendo planes públicos:', error)
    throw error
  }
}

/**
 * Obtener planes por tipo
 * @param {string} tipo - Tipo de plan (FAMILIAR, CORPORATIVO, etc.)
 */
export const obtenerPlanesPorTipo = async (tipo) => {
  try {
    const response = await fetch(`${API_BASE_URL}/planes/publico/tipo/${tipo}`)
    if (!response.ok) {
      throw new Error(`HTTP ${response.status}: ${response.statusText}`)
    }
    const data = await response.json()

    // Filtrar el plan con id=1 (Plan Help) - no mostrarlo en registro público
    const planesVisibles = data.filter(plan => plan.id !== 1)

    return planesVisibles
  } catch (error) {
    console.error('Error obteniendo planes por tipo:', error)
    throw error
  }
}

/**
 * Obtener distritos
 */
export const obtenerDistritos = async () => {
  try {
    const response = await fetch(`${API_BASE_URL}/distritos/publico`)
    if (!response.ok) {
      throw new Error(`HTTP ${response.status}: ${response.statusText}`)
    }
    const data = await response.json()
    return data
  } catch (error) {
    console.error('Error obteniendo distritos:', error)
    throw error
  }
}

/**
 * Obtener entidades externas activas
 */
export const obtenerEntidadesExternas = async () => {
  try {
    const response = await fetch(`${API_BASE_URL}/entidades_externas/publico/listar`)
    if (!response.ok) {
      throw new Error(`HTTP ${response.status}: ${response.statusText}`)
    }
    const data = await response.json()
    return data.entidades || []
  } catch (error) {
    console.error('Error obteniendo entidades externas:', error)
    throw error
  }
}

/**
 * Validar disponibilidad de DNI y email
 * @param {string} dni - DNI a validar
 * @param {string} email - Email a validar
 */
export const validarDisponibilidad = async (dni, email) => {
  try {
    const params = new URLSearchParams()
    if (dni) params.append('dni', dni)
    if (email) params.append('email', email)

    const response = await fetch(`${API_BASE_URL}/solicitudes_registro/publico/validar?${params}`)
    if (!response.ok) {
      throw new Error(`HTTP ${response.status}: ${response.statusText}`)
    }
    const data = await response.json()
    return data
  } catch (error) {
    console.error('Error validando disponibilidad:', error)
    throw error
  }
}

/**
 * Crear solicitud de registro
 * @param {Object} solicitud - Datos de la solicitud
 */
export const crearSolicitudRegistro = async (solicitud) => {
  try {
    const response = await fetch(`${API_BASE_URL}/solicitudes_registro/publico`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(solicitud)
    })

    if (!response.ok) {
      const errorData = await response.json()
      throw new Error(errorData.mensaje || `HTTP ${response.status}: ${response.statusText}`)
    }

    const data = await response.json()
    return data
  } catch (error) {
    console.error('Error creando solicitud de registro:', error)
    throw error
  }
}